"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _customPage = require("@/api/customPage");
var _addBanner = _interopRequireDefault(require("./addBanner.vue"));
var _categoryPop = _interopRequireDefault(require("../home/components/categoryPop.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    addBanner: _addBanner.default,
    categoryPop: _categoryPop.default
  },
  data: function data() {
    return {
      categoryId: '',
      puzzleList: [],
      searchStyle: '',
      shopListStyle: 0,
      realObj: {
        0: {
          text: '未开始',
          color: '#E6A23C',
          src: require('@/assets/pcl2.png')
        },
        1: {
          text: '上线中',
          color: '#67C23A',
          src: ''
        },
        2: {
          text: '已下线',
          color: '#F56C6C',
          src: require('@/assets/pcl1.png')
        }
      },
      componentCode: '',
      componentSubcode: '',
      id: '',
      dialogVisible: false,
      popTitle: '',
      title: '',
      status: '',
      options: [{
        label: '启用',
        value: 1
      }, {
        label: '停用 ',
        value: 0
      }],
      tableData: []
    };
  },
  methods: {
    changeCategory: function changeCategory(val) {
      console.log(val.categoryId);
      this.$refs.categoryPop.open({
        bannerId: val.categoryId,
        type: 0,
        moduleId: this.id
      });
    },
    saveShopStyle: function saveShopStyle() {
      var _this = this;
      this.$confirm('是否确认保存 ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.saveOrUpdateBanner)({
          moduleId: _this.id,
          shopListStyle: _this.shopListStyle
        }).then(function (res) {
          if (res.data) {
            _this.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          }
          _this.findList();
          _this.$emit('refresh', _this.id);
        });
      });
    },
    saveIt: function saveIt() {
      var _this2 = this;
      this.$confirm('是否确认保存 ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.saveOrUpdateBanner)({
          moduleId: _this2.id,
          searchStyle: _this2.searchStyle
        }).then(function (res) {
          if (res.data) {
            _this2.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          }
          _this2.findList();
          _this2.$emit('refresh', _this2.id);
        });
      });
    },
    needRefresh: function needRefresh() {
      // 通知组件刷新（单个组件）
      this.findList();
      this.$emit('refresh', this.id);
    },
    del: function del(val) {
      var _this3 = this;
      console.log(val);
      //   deleteBanner({
      //     bannerId:val.bannerId
      //   })
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.deleteBanner)({
          bannerId: val.bannerId
        }).then(function (res) {
          if (res.data) {
            _this3.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          }
          _this3.findList();
          _this3.$emit('refresh', _this3.id);
        });
      });
    },
    onClose: function onClose() {
      this.title = '';
      this.status = '';
      this.tableData = [];
      this.dialogVisible = false;
    },
    add: function add() {
      this.$refs.addBanner.open({
        name: '新增',
        type: 'add',
        moduleId: this.id,
        mType: this.componentCode === 'bannerWithPuzzle' || this.componentCode === 'verticalBannerWithPuzzle' ? '2' : '',
        componentCode: this.componentCode,
        componentSubcode: this.componentSubcode,
        categoryId: this.categoryId
      });
    },
    detail: function detail(val, text) {
      this.$refs.addBanner.open({
        name: '编辑',
        type: 'upDate',
        moduleId: this.id,
        bannerId: val.bannerId,
        componentCode: this.componentCode,
        componentSubcode: this.componentSubcode,
        categoryId: this.categoryId
      });
      // if (text === 'noNeed') {
      //   this.$refs.addBanner.open({ name: '编辑', type: 'upDate', moduleId: this.id, bannerId: val.bannerId, componentSubcode: this.componentSubcode, componentCode: this.componentCode })
      // } else {
      //   this.$refs.addBanner.open({ name: '编辑', type: 'upDate', moduleId: this.id, bannerId: val.bannerId, componentCode: this.componentCode, componentSubcode: this.componentSubcode })
      // }
    },
    bannerBuff: function bannerBuff(val) {
      this.$refs.addBanner.open({
        name: '编辑营销位',
        type: 'upDate',
        moduleId: this.id,
        bannerId: val.categoryId,
        componentCode: this.componentCode
      });
    },
    open: function open(data) {
      console.log(data);
      this.popTitle = data.name;
      this.componentSubcode = data.componentSubcode;
      this.componentCode = data.componentCode;
      this.id = data.id;
      if (this.componentCode === 'diamond' && this.componentSubcode === 's_a_c') {
        this.categoryId = data.categoryId;
      }
      this.findList();
      this.dialogVisible = true;
    },
    findList: function findList() {
      var _this4 = this;
      if (this.componentCode === 'diamond' && this.componentSubcode === 's_a_c') {
        (0, _customPage.diamondCategoryList)({
          categoryId: this.categoryId,
          bannerName: this.title,
          status: this.status
        }).then(function (res) {
          _this4.tableData = res.data.banner;
        });
      } else {
        (0, _customPage.moduleDetail)({
          moduleId: this.id,
          bannerName: this.title,
          status: this.status
        }).then(function (res) {
          console.log(res);
          if (_this4.componentCode === 'bannerWithPuzzle' || _this4.componentCode === 'verticalBannerWithPuzzle') {
            _this4.tableData = res.data.carouselBanner;
            _this4.puzzleList = res.data.banner;
          } else if (_this4.componentCode === 'bottomShopList') {
            _this4.tableData = res.data.bottomShopList.categoryList;
            _this4.shopListStyle = res.data.bottomShopList.shopListStyle;
          } else {
            _this4.tableData = res.data.banner;
          }
          if (_this4.componentCode === 'topSearch') {
            _this4.searchStyle = res.data.searchStyle * 1;
          }
        });
      }
    },
    clear: function clear() {
      this.title = '';
      this.status = '';
      this.findList();
    },
    search: function search() {
      this.findList();
    }
  }
};